import React from 'react';
import { useHistory } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { deleteBlockById } from './requests';

export default function Columns(handleRemove = () => {}) {
  const history = useHistory();
  return [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Имя',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'sort',
      label: 'Позиция',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'status',
      label: 'Статус',
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          if (value === 0) {
            return 'Невидимый';
          }
          if (value === 1) {
            return 'Видимый';
          }
          return 'Неизвестно';
        },
      },
    },
    {
      name: '',
      label: 'Управление',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <>
            <IconButton
              onClick={() => {
                const id = tableMeta.rowData[0];
                history.push(`/admin/streams/audio/update/${id}`);
              }}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              onClick={async () => {
                if(window.confirm('Вы уверены, что хотите удалить?')){
                  const id = tableMeta.rowData[0];
                  const { rowIndex } = tableMeta;
                  console.log(id);
                  await deleteBlockById(id);
                  handleRemove(rowIndex);
                  window.location.reload();
                }
              }}
            >
              <DeleteIcon />
            </IconButton>
          </>
        ),
      },
    },
  ];
}
